/**
 * Return locale from meta tag in document head
 * @returns {string} - String with either locale from meta tag or ""
 */
export const getDocLocale = (): string => {
  const headEl = <HTMLElement>window.self.document.querySelector("head");
  const metaEl = <HTMLElement>headEl.querySelector("meta[name='locale']");
  const locale = metaEl ? <string>metaEl.getAttribute("content") : "de-DE";
  return locale;
};
